<template>
  <div>
    <pcHeader></pcHeader>
  </div>
</template>
<script>
import pcHeader from '@/components/pcHeader'
import { selectByListId, getByListId } from '@/api/common'
export default {
  components: { pcHeader },
  data() {
    return {
      headData: [] // 头部信息
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  created() {
    this.getSelectByListId()
  },
  mounted() {},
  watch: {},
  methods: {
    async getSelectByListId() {
      const { data: res } = await selectByListId({ id: this.id })
      if (res.resultCode == 200) {
        this.headData = res.data
      }
    }
  }
}
</script>
<style scoped lang="less"></style>
